import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ArrowUpRight, Facebook, Twitter, Instagram, Linkedin } from "lucide-react";
import { company, nav, services } from "../mock";

const Footer = () => {
  return (
    <footer className="bg-[#0B102D] text-white/70">
      {/* CTA strip */}
      <div className="max-w-[1320px] mx-auto px-5">
        <div className="bg-[#CD0008] rounded-lg -mt-16 relative z-10 px-8 py-10 md:px-14 md:py-12 flex flex-col md:flex-row items-center justify-between gap-6">
          <h3 className="section-heading text-white text-2xl md:text-3xl max-w-xl">
            Ready to start your project with a builder you can trust?
          </h3>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 bg-[#0B102D] hover:bg-black text-white font-display font-semibold uppercase tracking-wide px-8 py-4 rounded-sm transition-colors whitespace-nowrap"
          >
            Get a Quote <ArrowUpRight size={18} />
          </Link>
        </div>
      </div>

      <div className="max-w-[1320px] mx-auto px-5 pt-16 pb-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <Link to="/" className="flex items-center mb-5">
            <img src="/salmons-logo.png" alt="Salmons Brothers logo" className="h-11 w-auto object-contain" />
          </Link>
          <p className="text-sm leading-relaxed mb-5">{company.intro}</p>
          <div className="flex items-center gap-3">
            {[Facebook, Twitter, Instagram, Linkedin].map((Icon, i) => (
              <a
                key={i}
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-white/15 hover:bg-[#CD0008] hover:border-[#CD0008] text-white transition-colors"
              >
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="font-display font-bold text-white text-lg mb-5">Quick Links</h4>
          <ul className="space-y-3 text-sm">
            {nav.map((n) => (
              <li key={n.to}>
                <Link to={n.to} className="hover:text-[#CD0008] transition-colors">{n.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold text-white text-lg mb-5">Our Services</h4>
          <ul className="space-y-3 text-sm">
            {services.slice(0, 5).map((s) => (
              <li key={s.id}>
                <Link to="/services" className="hover:text-[#CD0008] transition-colors">{s.title}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold text-white text-lg mb-5">Get In Touch</h4>
          <ul className="space-y-4 text-sm">
            <li className="flex gap-3">
              <MapPin size={20} className="text-[#CD0008] shrink-0" />
              <span>{company.address}</span>
            </li>
            <li className="flex gap-3 items-center">
              <Phone size={18} className="text-[#CD0008] shrink-0" />
              <a href={company.phoneHref} className="hover:text-[#CD0008] transition-colors">{company.phone}</a>
            </li>
            <li className="flex gap-3 items-center">
              <Mail size={18} className="text-[#CD0008] shrink-0" />
              <a href={`mailto:${company.email}`} className="hover:text-[#CD0008] transition-colors break-all">{company.email}</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1320px] mx-auto px-5 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-sm">
          <p>© {new Date().getFullYear()} {company.name}. All rights reserved.</p>
          <p>Family run &amp; trusted since {company.since}.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
